import { createDocumentContentStore } from '../Report/ReportContent/reportContentStore.js'

export const REQUEST_CONTENT_ICON_PREFIX = '/delta/dist/request_contents/svg/'
export const REQUEST_SECTIONS_ICONS = {
  'section-active-requests': 'active-requests.svg',
  'section-photos': 'photos.svg',
  'section-attachments': 'attachments.svg',
  'section-tech-task': 'tech-task.svg',
  'section-comments': 'comments.svg',
  'section-roads-codd': 'vis.svg',
  'section-roads-info': 'vis-info.svg',
  'section-roads-reject-reopen': 'reject-reopen.svg',
  'section-roads-integration': 'integration.svg',
  'section-roads-labels': 'roads-labels.svg',
  'section-mgt-info': 'vis-info.svg',
  'section-bp-history': 'bp-history.svg',
  'section-request-info': 'request.svg',
  'section-request-source': 'request-source.svg',
  'section-request-data-source': 'request-data-source.svg',
  'section-delivery-vis': 'delivery-vis.svg',
  'section-vis-id': 'vis-id.svg',
  'section-request-type': 'request-type.svg',
  'section-create-time': 'create-time.svg',
  'section-deadline': 'deadline.svg',
  'section-initiator': 'initiator.svg',
  'section-applicant-description': 'applicant-description.svg',
  'section-service-object-info': 'service-object.svg',
  'section-service-object': 'service-object.svg',
  'section-contract': 'contract.svg',
  'section-object-address': 'object-address.svg',
  'section-address': 'address.svg',
  'section-coordinates': 'coordinates.svg',
  'section-maintenance-notes': 'service-object-maintenance-notes.svg',
  'section-priority': 'priority.svg',
  'section-request-priority': 'request-priority.svg',
  'section-service-object-priority': 'service-object-priority.svg',
  'section-special-condition': 'special-condition.svg',
  'section-works': 'works.svg',
  'section-works-scope': 'works-scope.svg',
  'section-contractor-works': 'contractor-works.svg',
  'section-auto-assign-works': 'auto-assign-works.svg',
  'section-executor': 'executor.svg',
  'section-redirected-work-area': 'redirected-work-area.svg',
  'section-auto-assign': 'auto-assign.svg',
  'section-auto-assign-start': 'auto-assign-start.svg',
  'section-current-executor': 'brigade-number.svg',
  'section-forklift': 'forklift.svg',
  'section-works-check': 'works-check.svg',
  'section-reports-history': 'reports-history.svg'
}

export default createDocumentContentStore({
  iconUrlPrefix: REQUEST_CONTENT_ICON_PREFIX,
  sectionsIcons: REQUEST_SECTIONS_ICONS,
  storageKeyPrefix: 'delta.requestContent'
})
